import { Check, AlertCircle } from "lucide-react";
const B = process.env.REACT_APP_BACKEND_URL;

export function StepGeneric({ options, selected, onSelect, stepId, config, selection, categoryImages }) {
  const constraints = config?.constraints?.[stepId] || {};
  const img = (id) => {
    const u = categoryImages?.[stepId + "s"]?.[id] || categoryImages?.[stepId]?.[id];
    return u ? `${B}${u}` : null;
  };
  const fp = (p) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(p);

  const isDisabled = (optId) => {
    const c = constraints[optId];
    if (!c) return false;
    // Legacy support: excluded_when_board
    const excludedBoards = c.excluded_when_board || [];
    if (excludedBoards.length > 0 && excludedBoards.includes(selection?.board)) return c.message || "Non disponible";
    // New: excluded_when_board_type (for board_types restructure)
    const excludedBoardTypes = c.excluded_when_board_type || [];
    if (excludedBoardTypes.length > 0 && excludedBoardTypes.includes(selection?.board_type)) return c.message || "Non disponible";
    return false;
  };

  if (!options || options.length === 0) {
    return <div className="flex items-center justify-center h-48 text-[#888]"><p>Aucune option disponible</p></div>;
  }

  return (
    <div data-testid={`step-${stepId}`}>
      <p className="text-sm text-[#888] mb-6">{options.length} option{options.length > 1 ? "s" : ""} disponible{options.length > 1 ? "s" : ""}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {options.map(opt => {
          const disabled = isDisabled(opt.id);
          const sel = selected === opt.id;
          const iu = img(opt.id);
          return (
            <button
              key={opt.id}
              onClick={() => !disabled && onSelect(opt.id)}
              disabled={!!disabled}
              data-testid={`${stepId}-${opt.id}`}
              className={`relative p-5 rounded-xl border text-left transition-all ${
                disabled ? "opacity-40 cursor-not-allowed border-[#1A3A1A] bg-[#0B0B0B]"
                : sel ? "border-[#39FF14] bg-[#39FF14]/5 card-active"
                : "border-[#1A3A1A] bg-[#0B0B0B] hover:border-[#39FF14]/50 card-hover"
              }`}
            >
              {sel && (
                <div className="absolute top-3 right-3 w-6 h-6 rounded-full bg-[#39FF14] flex items-center justify-center z-10">
                  <Check className="w-4 h-4 text-black" />
                </div>
              )}
              {disabled && (
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded bg-red-900/50 border border-red-500/30">
                  <AlertCircle className="w-3 h-3 text-red-400" />
                  <span className="text-xs text-red-400">Incompatible</span>
                </div>
              )}
              {iu && (
                <div className="product-image-showcase w-full h-40 mb-3 bg-gradient-to-b from-[#111] to-[#0D1F0D] flex items-center justify-center rounded-lg">
                  <img src={iu} alt={opt.name} className="w-full h-full object-contain p-3" />
                </div>
              )}
              <div className="flex items-center gap-2 mb-2">
                <h4 className="text-lg font-bold text-white">{opt.name}</h4>
                {opt.badge && (
                  <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${
                    opt.badgeType === "green" ? "badge-green"
                    : opt.badgeType === "gold" ? "badge-gold"
                    : "bg-[#1A3A1A] text-[#888]"
                  }`}>{opt.badge}</span>
                )}
              </div>
              <p className="text-sm text-[#888] mb-2">{opt.desc}</p>
              {opt.detail && <p className="text-xs text-[#888] border-t border-[#1A3A1A] pt-2 mb-2">{opt.detail}</p>}
              {opt.price_ht != null && (
                <div className="mt-2 pt-2 border-t border-[#1A3A1A]">
                  <span className="text-[#39FF14] font-bold text-lg">{fp(opt.price_ht)}</span>
                  <span className="text-xs text-[#888] ml-1">HT</span>
                </div>
              )}
              {disabled && <p className="text-xs text-red-400 mt-2">{disabled}</p>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
